import * as React from "react";
import styled from "styled-components";
import * as _ from "lodash";
import StyledModal from "styled-react-modal";

import { Icon } from "../Icon";
import { Text } from "../Text";
import { Icons } from "../Icon/types";

export interface BasicModalProps extends Pick<React.HTMLAttributes<HTMLDivElement>, "className"> {
  open: boolean;
  onDismiss: () => void;
  title: string;
  body?: string;
}

export const BasicModal: React.ReactFCWithChildren<BasicModalProps> = ({
  children,
  onDismiss,
  open,
  title,
  body,
  ...rest
}) => {
  return (
    <ModalWrapper
      isOpen={open}
      onBackgroundClick={() => onDismiss()}
      {...rest}
    >
      <ModalInner>
        <div className="modal-header">
          <Icon
            className="close-icon"
            icon={Icons.CLOSE}
            onClick={() => onDismiss()}
          />

          <Text
            className="modal-title"
            as="h2"
            fontSize="h2"
          >
            {title}
          </Text>

          {body && (
            <Text
              as="p"
              className="modal-body"
            >
              {body}
            </Text>
          )}
        </div>

        {children}
      </ModalInner>
    </ModalWrapper>
  );
};

const ModalWrapper = StyledModal.styled`
    opacity: 1;
    position: relative;
    background: #fff;
    border-radius: 1rem;
    width: 50rem;
    max-width: 100vw;
    min-height: 100px;
    max-height: 80vh;
    overflow-y: scroll;

    @media(min-width: 700px) {
      max-height: 90vh;
    }
`;

ModalWrapper.displayName = "ModalWrapper";

const ModalInner = styled.div`
  padding: 3rem 2.4rem;

  .modal-header {
    position: relative;
    padding-bottom: 3rem;

    .modal-title,
    .modal-body {
      margin: 0;
    }

    .modal-body {
      padding-top: 1.2rem;
    }

    .close-icon {
      position: absolute;
      top: 0.2rem;
      right: 0rem;
      cursor: pointer;
    }
  }
`;
